import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Form, InputNumber, Modal } from 'antd';
import dayjs from "dayjs";
import { axiosErrorHandler } from "../../../../../swzutils";
const UpdateStoredPaymentMethodExpiryModal = (props) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateError, setStateError] = useState(null);
    const formRef = useRef(null);
    useEffect(() => {
        if (props.open) {
            setStateError(null);
            formRef.current?.resetFields();
        }
    }, [props.open]);
    const updateExpiry = (formValues) => {
        setStateLoading(true);
        let url = `/admin/v1/billing/payment-methods/${props.paymentMethod.id}`;
        if (props.tenantId) {
            url += `?tenantId=${props.tenantId}`;
        }
        axios.patch(url, {
            expMonth: formValues.expMonth,
            expYear: formValues.expYear + 2000
        }).then(( /*response*/) => {
            setStateError(null);
            props.onUpdated();
        }).catch((error) => {
            axiosErrorHandler(error, (errorMessage) => {
                setStateError(errorMessage);
            });
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const onFinish = (formValues) => {
        updateExpiry(formValues);
    };
    const currentYear = dayjs().year() - 2000;
    return (_jsxs(Modal, { title: "Edit Credit Card Expiry", open: props.open, onCancel: props.onCancel, onOk: () => formRef.current?.submit(), confirmLoading: stateLoading, children: [_jsxs(Form, { layout: "inline", ref: formRef, onFinish: onFinish, children: [_jsx(Form.Item, { name: "expMonth", label: "Expiry", rules: [
                            { required: true, message: 'Required' }
                        ], children: _jsx(InputNumber, { placeholder: "MM", min: 1, max: 12 }) }), _jsx(Form.Item, { name: "expYear", label: "/", colon: false, rules: [
                            { required: true, message: 'Required' }
                        ], children: _jsx(InputNumber, { placeholder: "YY", min: currentYear, max: currentYear + 19 }) })] }), stateError &&
                _jsx("div", { className: "ant-form-item-control has-error", children: _jsx("div", { className: "ant-form-explain", children: stateError }) })] }));
};
export default UpdateStoredPaymentMethodExpiryModal;
